module.exports = __webpack_public_path__ + "static/media/MASTER_CARD.0d393efd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/MASTER_CARD.svg
// module id = 80
// module chunks = 0